import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNotice } from "../../redux/slices/notifSlice";

const NoticeMirage = () => {
  const dispatch = useDispatch();
  const { showMarquee, noticeMarquee } = useSelector((state) => state.notif);

  useEffect(() => {
    dispatch(fetchNotice());
  }, []);

  if (!showMarquee) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white py-2 shadow-lg">
      <div className="overflow-hidden whitespace-nowrap">
        <div className="animate-marquee inline-block">
          {noticeMarquee}
        </div>
      </div>
    </div>
  );
};

export default NoticeMirage;
